import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import { Patient, PatientLight } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { useRouterHook } from "@/src/utils/routerHook";
import { getAge, getShortPatientId } from "@/src/utils/utils";
import { useRef, useState } from "react";
import { AiDescription } from "../aiTasks/aiDescription";

export function PatientsListItem({
  patient,
  selectedPatient,
  onSelect,
  searchKey,
}: {
  patient: PatientLight | Patient;
  selectedPatient: Patient | null | undefined;
  onSelect?: (patient: Patient) => void;
  searchKey: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { addParamToUrl } = useRouterHook();
  const ref = useRef<HTMLDivElement>(null);
  async function onClick() {
    setIsLoading(true);
    let fullPatient = await apiFetch("patients", "loadOne", {
      id: patient.id,
    });

    if (!fullPatient) throw new Error("Impossible de charger le patient");
    await onSelect?.(fullPatient);
    addParamToUrl("patientId", patient.id?.split(":")[1]);
    setIsLoading(false);
  }
  return (
    <AiDescription
      item={{
        title: `${patient.lastName} ${patient.firstName}`,
        type: "card",
        description: "A list element of patients list",
        ref,
        onClick: onClick,
      }}
    >
      <div
        ref={ref}
        key={patient.id}
        className={`patient_item ${
          selectedPatient?.id === patient.id ? "active" : ""
        }
        ${isLoading ? "disabled" : ""}
        `}
        onClick={async () => {
          console.log(patient.id);
          console.log(getShortPatientId(patient.id));
          await onClick();
        }}
      >
        <div className="patient_item_name bold  capitalize">
          <SearchKeyHighliter searchKey={searchKey}>
            {`${patient.lastName} ${patient.firstName}`.toLowerCase()}
          </SearchKeyHighliter>
        </div>
        <div className="gray">{`${getAge(patient)}`}</div>
      </div>
    </AiDescription>
  );
}
